// extracted by mini-css-extract-plugin
export default {"name":"aFH0jg","description":"JmNJBr"};